module.exports = __webpack_public_path__ + "img/jx-emptry.82fb2d62.png";